import ExaminationResultLayout from './ExaminationResultLayout';

export default ExaminationResultLayout;
